var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getGameConsole === 'american')?_c('MarketViewLiveDetailV5American'):(_vm.getGameConsole === 'terminal')?_c('MarketViewLiveDetailV5Terminal'):_c('MarketViewLiveDetailV5Classic')
}
var staticRenderFns = []

export { render, staticRenderFns }